// Logo WÔMA de ARTEKNOS — image circulaire dorée, utilisée sur Landing + dashboards.
// Fichier source: /app/frontend/public/woma-logo.png
export default function WomaLogo({ size = 56, className = "", showTagline = false }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="woma-logo-root">
      <img
        src="/woma-logo.png"
        alt="WÔMA de ARTEKNOS"
        width={size}
        height={size}
        className="rounded-full ring-2 ring-[#D4AF37]/40 shadow-[0_0_18px_rgba(212,175,55,0.35)]"
        style={{ width: size, height: size, objectFit: "cover" }}
        loading="eager"
        data-testid="woma-logo-img"
      />
      {showTagline && (
        <div className="leading-tight">
          <p className="font-black text-lg tracking-tight text-white">WÔMA</p>
          <p className="text-[10px] font-bold uppercase tracking-widest text-[#D4AF37]">
            de ARTEKNOS
          </p>
        </div>
      )}
    </div>
  );
}
